import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const ClientAnswer = ({ clientAnswers }) => {
  const { currentLanguage } = useSelector((state) => state.languageReducer);

  return (
    <Stack gap={0.4} p={2} border={"1px solid grey"} borderRadius={1}>
      {clientAnswers?.map((val, index) => {
        return (
          <Box key={index}>
            <Typography>
              Q<sub>{index + 1}</sub>. {val.question[currentLanguage]}
            </Typography>
            <Typography color="text.slateGray">A. {val.answer}</Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export default ClientAnswer;
